import { Injectable } from "@angular/core";
import { HttpParams, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IGetHouseList {
  page: number;
  page_size: number;
  house_type_id?: number;
  group_id?: number;
}

const GET_GROUP_LIST_API = "/api/house_group/group_list";
const GET_HOUSE_TYPE_LIST_API = "/api/house_type/all";
const GET_TRANSACTION_HOUSE_LIST_API = "api/transaction/house_list";

@Injectable()
export class SearchHouseInGroupAndTypeService {
  constructor(private http: HttpClient) {}

  /** 获取全部房源分组 */
  getGroupList() {
    return this.http.get(GET_GROUP_LIST_API) as Observable<IHttpResponse>;
  }

  /** 获取房型列表 */
  getHouseTypeList() {
    return this.http.get(GET_HOUSE_TYPE_LIST_API) as Observable<IHttpResponse>;
  }

  /** 获取交易房源分组列表 */
  getTransactionHouseList(params: IGetHouseList) {
    const query = new HttpParams()
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`)
      .append("house_type_id", `${params.house_type_id}`)
      .append("group_id", `${params.group_id}`);
    return this.http.get(GET_TRANSACTION_HOUSE_LIST_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }
}
